export const KEYCLOAK_TOKENS = 'keycloak-tokens';
export const DEFAULT_LOCALE = navigator.language
  ? navigator.language.split(/[-_]/)[0]
  : 'en';
